module.exports = __webpack_public_path__ + "img/bedroom_full.df157a5e.jpg";